import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-show-kit-info',
    templateUrl: './show-kit-info.component.html',
    styleUrls: ['./show-kit-info.component.scss'],
    standalone: false
})
export class ShowKitInfoComponent implements OnInit {
  container: any = {};
  @ViewChild("gridInput") gridInput: any;
  constructor(
    public Injector: Injector,
    public loader: LoaderService,
    private dialogConfig: DialogConfig,
    private baseService: BaseService,
    public dialog: DialogRef,
    public alerts: AlertsService
  ) {

  }

  ngOnInit(): void {
    this['data'] = this.dialogConfig;
    this.container.items = [];
    this.container.isLocalData = false;
    this.container.current_index = this['data'].data.data.hasOwnProperty('event') ? this['data'].data.data.event.index : null;
    this.getItemDetails();
  }
  getDupValueIndex(temp1) {
    let firstIndex;
    for (let i = 0; i < temp1.length; i++) {
      if (temp1.indexOf(temp1[i]) != temp1.lastIndexOf(temp1[i])) {
        firstIndex = i;
        return firstIndex;
      }
    }
  }
  closePopUp() {
    try {
      this.loader.showSpinner();
      if (this.gridInput.editableTable.status == 'INVALID') {
        this.alerts.error("Please enter Required fields.");
        this.loader.hideSpinner();
        return
      }
      let gridData = this.gridInput?.editableTable?.controls?.editableRows?.getRawValue();
      if (gridData && gridData.length > 0) {
        let isFalse = false;
        for (let d of gridData) {

          if (!d.fractionalStock) {
            let issueQty = d.qty;
            if (issueQty != '' && issueQty != undefined) {
              if (!Number.isInteger(issueQty)) {
                this.alerts.error(`${d.itemName} is not a fractional item, Remove decimal from issue Quantity`);
                isFalse = true;
                break;
              }
            }
          } else if (d.fractionalStock) {
            let issueQty = d.qty;
            if (issueQty && !Number.isInteger(issueQty)) {
              var regex = /^\d+(\.\d{1,2})?$/;
              if (!regex.test(issueQty)) {
                this.alerts.error(`Only two digit allowed after decimal.`);
                isFalse = true;
                break;
              }
            }
          }

          if (!d.batch_no) {
            this.alerts.error("Please select batch no.");
            isFalse = true;
            break;
          }
          if (!d.qty) {
            this.alerts.error("Please enter Quantity.");
            isFalse = true;
            break;
          }
          if (d.qty > d.kit_qty) {
            this.alerts.error("Issued Quantity can not be more than Kit Quantity.");
            isFalse = true;
            break;
          }
          if (d.qty > d.stock) {
            this.alerts.error("Issued Quantity can not be more than Stock.");
            isFalse = true;
            break;
          }
          // Checking item Qty should not be greater than Kit Qty
          let sumofQty = gridData.filter((f) => { return f.itemCode == d.itemCode });
          if (sumofQty && sumofQty.length > 0) { // It means same itemcode present with multiple rows
            let kitQty = d.kit_qty;
            let totalQty = +sumofQty.map((d) => { return +d.qty }).reduce((d, t) => d + t).toFixed(2);
            if (kitQty != totalQty) {
              this.alerts.error(`Issued Quantity should be equal to kit Qty (${kitQty}) for ${d.itemName}.`);
              isFalse = true;
              break;
            }
          }
          // Checking same item with duplicate batch which is not allowed.
          let valueArr = gridData.map(function (item) { return item.itemCode + item.batch_no; });
          let isDuplicate = valueArr.some(function (item, idx) { return valueArr.indexOf(item) != idx; });
          if (isDuplicate) {
            let dupIndex = this.getDupValueIndex(valueArr);
            this.alerts.error(`Same item with Duplicate Batches not allowed. ItemName - ${gridData[dupIndex].itemName}, Batch No - ${gridData[dupIndex].batch_no}`);
            isFalse = true;
            break;
          }
        }
        if (isFalse) {
          this.loader.hideSpinner();
          return;
        }
        let data = {
          items: this.container.editableGrid.map((d) => { return d.getRawValue() }),
          event: this.container.current_index
        }
        this.dialog.close(data);
        this.loader.hideSpinner();
      }
    } catch (error) {
      this.loader.hideSpinner();
    }

  }
  listen_changesinShowKitInfo(event) {
    // if(event && event.type == "data_binded"){
    //   this.container.kitItemsLength
    // }

    if (event && event.editableGrid && event.type == "dropdown_binded" && event.index != undefined) {
      if (event.editableGrid && event.editableGrid[event.index].controls.batch_no.question_component && event.editableGrid[event.index].controls.stockDetails.value) {
        if (event.editableGrid[event.index].controls.stockDetails.value.length > 0) {
          if (!this.container.isLocalData) {
            let defaultBatch = event.editableGrid[event.index].controls.stockDetails.value.find((d) => { return d.is_default });
            if (Object.keys(defaultBatch).length > 0) {
              event.editableGrid[event.index].controls.stock.setValue(defaultBatch.itemQty ? defaultBatch.itemQty : 0);
              event.editableGrid[event.index].controls.batch_no.setValue(defaultBatch.batchNo ? defaultBatch.batchNo : '');
              event.editableGrid[event.index].controls.batch_no.question_component.question.options = event.editableGrid[event.index].controls.stockDetails.value;
              event.editableGrid[event.index].controls.expiryDate.setValue(defaultBatch.expiryDate ? defaultBatch.expiryDate : null);
              event.editableGrid[event.index].controls.fractionalStock.setValue(defaultBatch.fractionalStock ? defaultBatch.fractionalStock : false);
            }
          } else if (this.container.isLocalData) {
            event.editableGrid[event.index].controls.batch_no.question_component.question.options = event.editableGrid[event.index].controls.stockDetails.value;
            // if (this['data'].data.data.current_row.kitItems.length > 0) {
            //   for (let d of this['data'].data.data.current_row.kitItems) {
            //     if (d.stockDetails.length > 0) {
            //       let foundBatchNo = d.stockDetails.find(x => x.batchNo == d.batchNo);
            //       if (foundBatchNo) {
            //         d.stock = foundBatchNo.itemQty;
            //         d.expiryDate = foundBatchNo.expiryDate;
            //       } else {
            //         let defaultBatch = d.stockDetails.find((d) => { return d.is_default });
            //         if (Object.keys(defaultBatch).length > 0) {
            //           d.stock = (defaultBatch.itemQty ? defaultBatch.itemQty : 0);
            //           d.batchNo = (defaultBatch.batchNo ? defaultBatch.batchNo : '');
            //           d.expiryDate = (defaultBatch.expiryDate ? defaultBatch.expiryDate : null);
            //         }
            //       }
            //     }
            //   }
            // }
          }
        }
      }
    }
    if (event && event.editableGrid) {
      this.container.editableGrid = event.editableGrid;
    }
  }
  getItemDetails() {
    //Getting data from api when kit items is not present in row price_type (this['data'].data.data.current_row.kit_price_id || this['data'].data.data.current_row.itemKit_id)
    if (this['data'] && this['data'].data && this['data'].data.data.current_row.price_type == "Kit Price" && this['data'].data.data.current_row.kitItems.length == 0) {
      this.loader.showSpinner();
      var obj: any;
      let id = this['data'].data.data.current_row.kit_price_id ? this['data'].data.data.current_row.kit_price_id : this['data'].data.data.current_row.itemKit_id;
      obj = {
        id: id
      }
      // if(this['data'].data.data.current_row.kit_price_id=="" && this['data'].data.data.current_row.itemKit_id!=""){
      //   obj = {
      //     id:this['data'].data.data.current_row.itemKit_id
      //   }
      // }
      this.baseService.add(obj, "itemKitMapping", true, "inventory-management", "kit_item_detail").subscribe((res) => {
        if (res.errCode != -1 && res.resource && res.resource.length > 0) {
          let data = res.resource[0];
          if (data.kitItems && data.kitItems.length > 0) {
            this.container.items = data.kitItems;
            for (let d of this.container.items) {
              d.qty = d.quantity;
              d.kit_qty = d.quantity;
              d.id = d.itemId;
            }
            this.container.items = JSON.parse(JSON.stringify(this.container.items));
            this.container.isLocalData = false;
          }
        }
        if (res.errCode == -1) {
          this.alerts.error(res.message);
        }
        this.loader.hideSpinner();
      }, (err) => {
        console.log("err", err);
        this.loader.hideSpinner();
      })
    } else if (this['data'].data.data.current_row.kitItems.length > 0) {
      //Getting data from local variable once user clicked on info button
      this.container.items = JSON.parse(JSON.stringify(this['data'].data.data.current_row.kitItems));
      this.container.isLocalData = true;
      if (this['data'].data.data.current_row.kitItems.length > 0 && this.container.items.length > 0) {
        for (let d of this.container.items) {
          if (d.stockDetails.length > 0) {
            let foundBatchNo = d.stockDetails.find(x => x.batchNo == d.batch_no);
            if (foundBatchNo) {
              d.stock = foundBatchNo.itemQty;
              d.expiryDate = foundBatchNo.expiryDate;
              d.fractionalStock = foundBatchNo.fractionalStock;
            } else {
              let defaultBatch = d.stockDetails.find((d) => { return d.is_default });
              if (Object.keys(defaultBatch).length > 0) {
                d.stock = (defaultBatch.itemQty ? defaultBatch.itemQty : 0);
                d.batch_no = (defaultBatch.batchNo ? defaultBatch.batchNo : '');
                d.expiryDate = (defaultBatch.expiryDate ? defaultBatch.expiryDate : null);
                d.fractionalStock = (defaultBatch.fractionalStock ? defaultBatch.fractionalStock : false);
              }
            }
          }
        }
      }
    } else {
      //TODO
    }
  }
}
